import React, { useState, useRef, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PospNavBar } from "../Navbar/PospNav";
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Select,
  DatePicker,
  Switch,
  AutoComplete,
  Checkbox,
  message,
  Upload,
} from "antd/lib";
import { PlusOutlined } from "@ant-design/icons";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import moment from "moment";
import axios from "axios";
import { financierList } from "../../Redux/actions/NumBikeation";
import {
  Previousinsurer,
  quick_quotes_Bike,
  // QuickQuote_Post,
  // quick_quoteValues,
  PospDetails,
} from "../../Redux/actions/NumBikeation";

const Relation = [
  { label: "DAUGHTER" },
  { label: "DAUGHTER IN LAW" },
  { label: "GRAND CHILD" },
  { label: "HEAD" },
  { label: "WIFE" },
  { label: "MOTHER" },
  { label: "FATHER" },
  { label: "SON" },
  { label: "SPOUSE" },
  { label: "HUSBAND" },
  { label: "LONGTIME_PARTNER" },
  { label: "CHILD" },
  { label: "SISTER" },
  { label: "BROTHER" },
];

const PospDetail = (props) => {
  console.log(props.preinslist);
  const history = useHistory();
  const reg = useSelector((state) => state.vehicledetail.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const CustDetail = useSelector((state) => state?.common?.customerDetail);
  const QuickQuotePost = useSelector(
    (state) => state.vehicledetail.quickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.vehicledetail?.quoteInput);

  const PospQuotePost = useSelector((state) => state.posp.PospDetails);
  const EngData = useSelector((state) => state.addressdetail.info3);
  console.log(EngData);
  const [form] = Form.useForm();
  const { Option } = Select;
  const Ref = useRef(null);
  const dispatch = useDispatch();
  // const [QuotePost, setQuotePost] = useState(QuickQuotePost)
  const [loading, setLoading] = useState(false);
  const [showStep1, setShowStep1] = useState(false);
  const [options, setOptions] = useState([]);
  const [Financed, setFinanced] = useState(
    EngData?.financed === "YES" ? "YES" : "NO"
  );
  const [financiers, setFinanciers] = useState([]);
  const [isAddressSame, setIsAddressSame] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [RcfileList, setRcfileList] = useState([]);
  const [AadharfileList, setAadharfileList] = useState([]);
  const [PanfileList, setPanfileList] = useState([]);
  const [BaseUrl, setBaseURL] = useState(process.env.REACT_APP_UAT_BASE_URL);

  useEffect(() => {
    dispatch(Previousinsurer());
    dispatch(financierList()).then((res) => {
      console.log("financierList", res);
      const namesArray = Object.values(res);
      console.log(namesArray);
      setFinanciers(namesArray);
    });
  }, [dispatch, BaseUrl]);

  useEffect(() => {
    const url = `${BaseUrl}states`;
    const config = {
      headers: {
        Authorization: "Bearer " + reg.token,
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        console.log(res);
        const resp = res.data.data;
        console.log(resp);
        const statesArray = Object.keys(resp).map((id) => ({
          id,
          label: resp[id],
        }));
        setOptions(statesArray);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ PAN_Number: e.target.value });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const handleAddress = (e) => {
    console.log(e);
    setFinanced(e ? "YES" : "NO");
  };
  const handleCheckboxChange = (e) => {
    setIsAddressSame(e.target.checked);
    if (e.target.checked) {
      const addressValue = form.getFieldValue("address");
      const cityValue = form.getFieldValue("city");
      const stateValue = form.getFieldValue("state");
      const pincodeValue = form.getFieldValue("pincode");

      form.setFieldsValue({
        Regaddress: addressValue,
        Regcity: cityValue,
        Regstate: stateValue,
        Regpincode: pincodeValue,
      });
    } else {
      form.setFieldsValue({
        Regaddress: undefined,
        Regcity: undefined,
        Regstate: undefined,
        Regpincode: undefined,
      });
    }
  };
  const handleSearchFinance = (searchText) => {
    const filteredOptions = financiers.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setFinanciers(filteredOptions);
  };
  const AadharProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setAadharfileList([...AadharfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = AadharfileList.indexOf(file);
      const newFileList = AadharfileList.slice();
      newFileList.splice(index, 1);
      setAadharfileList(newFileList);
    },
    AadharfileList,
  };
  const PanProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setPanfileList([...PanfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = PanfileList.indexOf(file);
      const newFileList = PanfileList.slice();
      newFileList.splice(index, 1);
      setPanfileList(newFileList);
    },
    PanfileList,
  };
  const props1 = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setRcfileList([...RcfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = RcfileList.indexOf(file);
      const newFileList = RcfileList.slice();
      newFileList.splice(index, 1);
      setRcfileList(newFileList);
    },
    RcfileList,
  };
  const props2 = {
    multiple: false,
    accept: "application/pdf",
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    fileList,
  };

  const handleAadhaarNumberChange = (e) => {
    // Remove existing spaces and non-digit characters
    const inputValue = e.target.value.replace(/\s/g, "").replace(/\D/g, "");
    // Ensure a maximum of 12 digits
    const truncatedValue = inputValue.slice(0, 12);
    // Ensure it does not start with 0 or 1
    const formattedValue = truncatedValue.replace(/^[01]/, "");
    // Insert a space after every 4 digits
    const finalValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1 ");
    // Update the input value
    e.target.value = finalValue;
    form.setFieldsValue({ aadhaar_number: finalValue });
  };
  console.log(QuoteInput);
  const onFinish = (values) => {
    console.log("values", values);
    setLoading(true);
    console.log(values);
    values.owner_dob = moment(values.owner_dob).format("YYYY-MM-DD");
    values.Nage = moment(values.Nage).format("YYYY-MM-DD");
    const updatedQuotePost = {
      ...QuickQuotePost,
      firstName: values?.firstName,
      lastName: values?.lastName,
      address: values?.address,
      city: values?.city,
      state: values?.state,
      pincode: values?.pincode,
      MobileNumber: values?.MobileNumber,
      PAN_Number: values?.PAN_Number,
      email: values?.email,
      licensePlateNumber: values?.bikeNumber,
      Chasis: values?.Chasis,
      Engine: values?.Engine,
      PolicyNumber: values?.PolicyNumber,
      Regaddress: values?.Regaddress,
      Regcity: values?.Regcity,
      Regstate: values?.Regstate,
      Regpincode: values?.Regpincode,
      Nname: values?.Nname,
      Nrelation: values?.Nrelation,
      Ndob: values?.Nage,
      Financer: values?.Financer ? values?.Financer : null,
      agreementType: values?.agreementType ? values?.agreementType : "",
      FinancerCity: values?.FinancerCity ? values?.FinancerCity : "",
      aadhaar_number: values?.aadhaar_number,
      owner_dob: values?.owner_dob,
      is_acknowledgement_sent: false,
      insurance_id: 1,
    };
    // Create a FormData object
    const formData = new FormData();

    Object.keys(updatedQuotePost).forEach((key) => {
      formData.append(key, updatedQuotePost[key]);
    });
    QuoteInput?.required_insurers.forEach((insur, index) => {
      console.log(insur, index);
      formData.append(`required_insurers[${index}]`, insur);
    });
    if (QuoteInput?.Addons) {
      QuoteInput.Addons.forEach((insur, index) => {
        console.log(insur, index);
        formData.append(`addons[${index}]`, insur);
      });
    } else {
      formData.append("addons", null);
      console.log("Addons is null");
    }
    if (QuoteInput?.Additionl_covers) {
      QuoteInput.Additionl_covers.forEach((insur, index) => {
        console.log(insur, index);
        formData.append(`additional_covers[${index}]`, insur);
      });
    } else {
      formData.append("additional_covers", null);
    }
    if (QuoteInput?.seat_capacity) {
      formData.append(`seat_capacity`, QuoteInput?.seat_capacity);
    } else {
      formData.append("seat_capacity", null);
    }
    if (QuoteInput?.vehicle_gross_weight) {
      formData.append(`vehicle_gross_weight`, QuoteInput?.vehicle_gross_weight);
    } else {
      formData.append("vehicle_gross_weight", null);
    }
    formData.append("aadhaar_copy", AadharfileList[0]);
    formData.append("pancard_copy", PanfileList[0]);
    formData.append("rc_copy", RcfileList[0]);
    {
      QuoteInput?.insuranceProductCode === "Not_Secure"
        ? formData.append("policy_copy", "")
        : formData.append("policy_copy", fileList[0]);
    }
    console.log("formData", formData);
    axiosInPosp
      .post("v1/posp/quick_quotes", formData)
      .then((res) => {
        console.log(res);
        dispatch(PospDetails(updatedQuotePost));
        history.push("/PospMenu");
        console.log(res.message);
        if (res.status === 200) {
          let data = {
            data: res.data.data,
          };
          dispatch(quick_quotes_Bike(data));
          setLoading(false);
        } else {
          setLoading(false);
          message.error(res.data.error.validationMessages.join(","));
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
        if (err.response.data.message == "Unauthenticated.") {
          dispatch((dispatch) => {
            dispatch({ type: "LOGOUT_POSP" });
          });
          history.push("/");
        }
        setLoading(false);
        message.error(err.response.data.message);
      });
  };

  return (
    <>
      <PospNavBar />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <div className="col-xl-12 col-lg-6 px-3 col-md-6 bike-info-quotebef">
              <div
                className="h6 text-blue py-3 text-center mb-0"
                style={{ fontSize: "20px", fontWeight: "700" }}
              >
                Personal Details
              </div>
              <Form
                form={form}
                layout="vertical"
                style={{ width: "100%" }}
                //requiredMark={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label="First Name"
                      name="firstName"
                      rules={[
                        {
                          required: true,
                          message: "please input Name",
                        },
                      ]}
                      initialValue={PospQuotePost?.firstName}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="First Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Last Name"
                      name="lastName"
                      rules={[
                        {
                          required: true,
                          message: "please input Last Name",
                        },
                      ]}
                      initialValue={PospQuotePost?.lastName}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="Last Name"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Address"
                      name="address"
                      rules={[
                        {
                          required: true,
                          message: "please input Address",
                        },
                      ]}
                      initialValue={PospQuotePost?.address}
                    >
                      <Input style={{ width: "100%" }} placeholder="Address" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="City"
                      name="city"
                      rules={[
                        {
                          required: true,
                          message: "please input City",
                        },
                      ]}
                      initialValue={PospQuotePost?.city}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="City/District"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="state"
                      label="state"
                      rules={[
                        {
                          required: true,
                          message: "Please select State",
                        },
                      ]}
                      initialValue={PospQuotePost?.state}
                    >
                      <Select
                        defaultValue="Search for a state"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={options?.map((p) => ({
                          value: p.label,
                          label: p.label,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Pincode"
                      name="pincode"
                      rules={[
                        {
                          required: true,
                          message: "please input Pincode",
                        },
                      ]}
                      initialValue={PospQuotePost?.pincode}
                    >
                      <Input style={{ width: "100%" }} placeholder="Pincode" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Mobile Number"
                      name="MobileNumber"
                      rules={[
                        {
                          required: true,
                          // type: 'number',
                          message: "please input Mobile Number",
                        },
                      ]}
                      initialValue={PospQuotePost?.MobileNumber}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="Mobile Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      initialValue={PospQuotePost?.PAN_Number}
                      name="PAN_Number"
                      label="PAN Number"
                      rules={[
                        {
                          pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i,
                          message: "Invalid PAN Number",
                        },
                        { required: true, message: "Enter PAN Number" },
                      ]}
                    >
                      <Input
                        maxLength={10}
                        onChange={handleInputChange}
                        placeholder="Enter PAN Number"
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      initialValue={PospQuotePost?.aadhaar_number}
                      name="aadhaar_number"
                      label="Aadhaar Number"
                      rules={[
                        { required: true, message: "Enter Aadhaar Number" },
                        {
                          pattern:
                            /^(?!0|1)\d{4}(?!0|1)\s?\d{4}(?!0|1)\s?\d{4}$/,
                          message: "Invalid Aadhaar Number",
                        },
                      ]}
                    >
                      <Input
                        onChange={handleAadhaarNumberChange}
                        placeholder="Enter Aadhaar Number"
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Date of Birth"
                      name="owner_dob"
                      rules={[
                        {
                          required: true,
                          message: "Please select DOB",
                        },
                      ]}
                      initialValue={
                        PospQuotePost?.owner_dob
                          ? moment(PospQuotePost?.owner_dob)
                          : null
                      }
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        disabledDate={disabledDate}
                        defaultPickerValue={getDefaultPickerValue()}
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please Input Email",
                        },
                      ]}
                      initialValue={PospQuotePost?.email}
                    >
                      <Input
                        autoComplete="off"
                        style={{ width: "100%" }}
                        placeholder="Email"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      name="aadhaar_copy"
                      label="Aadhaar Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...AadharProps} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      name="pancard_copy"
                      label="Pancard Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...PanProps} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"center"}>
                  <div
                    className="h6 text-blue py-3 text-center mb-0"
                    style={{ fontSize: "20px", fontWeight: "700" }}
                  >
                    Vehicle Details
                  </div>
                </Row>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label="Vehicle Registration No."
                      name="bikeNumber"
                      rules={[
                        {
                          pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                          message: "Invalid Vehicle No",
                        },
                        { required: true, message: "Enter Vehicle No" },
                      ]}
                      initialValue={vechicleData?.rc_number}
                    >
                      <Input
                        // onChange={handleInputChange}
                        placeholder="Enter Vehicle Number (eg. DL1SAB1234)"
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Chasis Number"
                      name="Chasis"
                      rules={[
                        { required: true, message: "Enter Chasis Number" },
                      ]}
                      initialValue={
                        vechicleData?.vehicle_chasi_number
                          ? vechicleData?.vehicle_chasi_number
                          : PospQuotePost?.Chasis
                      }
                    >
                      <Input placeholder="Enter Chasis Number"></Input>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Engine Number"
                      name="Engine"
                      rules={[
                        { required: true, message: "Enter Engine Number" },
                      ]}
                      initialValue={vechicleData?.vehicle_engine_number}
                    >
                      <Input placeholder="Enter Engine Number"></Input>
                    </Form.Item>
                  </Col>
                  {QuoteInput?.insuranceProductCode === "Not_Secure" ? null : (
                    <>
                      <Col span={6}>
                        <Form.Item
                          //className="form-item-bg"
                          label="previous insurer"
                          name="previousInsurerCode"
                          rules={[
                            {
                              required: true,
                              message: "Please select previous insurer",
                            },
                          ]}
                          initialValue={QuickQuotePost?.previousInsurerCode}
                        >
                          <Select
                            disabled
                            defaultValue="Select your option"
                            showSearch
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            // onChange={handleChange}
                            options={props.preinslist?.map((p) => ({
                              key: p.id,
                              value: p.code,
                              label: p.name,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Previous Policy Number"
                          name="PolicyNumber"
                          rules={[
                            { required: true, message: "Enter Policy Number" },
                          ]}
                          initialValue={vechicleData?.insurance_policy_number}
                        >
                          <Input placeholder="Enter Policy Number"></Input>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                  <Col span={3}>
                    <Form.Item
                      name="rc_copy"
                      label="Rc Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...props1} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                  {QuoteInput?.insuranceProductCode === "Not_Secure" ? null : (
                    <Col span={4}>
                      <Form.Item
                        name="policy_copy"
                        label="Previous Policy Copy"
                        rules={[
                          {
                            required: true,
                            message: "Please Upload Policy Copy",
                          },
                        ]}
                      >
                        <Upload {...props2} maxCount={1}>
                          <Button
                            type="primary"
                            className="upload-btn"
                            icon={<PlusOutlined />}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <Row gutter={24}>
                  <p className="sameAddrrs">
                    Is your Vehicle Financed?
                    <span>No </span>
                    <Switch
                      size="small"
                      onChange={handleAddress}
                      defaultChecked={EngData?.financed === "YES"}
                    />
                    <span> Yes</span>
                  </p>
                </Row>
                {Financed === "YES" ? (
                  <Row gutter={24}>
                    <Col span={6}>
                      <Form.Item
                        name="Financer"
                        label="Select Financer"
                        rules={[
                          {
                            required: true,
                            message: "Please select Financer",
                          },
                        ]}
                        // initialValue={EngData?.Financer}
                      >
                        <Select
                          defaultValue="Search for a Financer"
                          showSearch
                          // filterOption={(input, option) =>
                          //   option.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          // }
                          options={financiers?.map((option, index) => ({
                            key: index,
                            value: option,
                          }))}
                          onSearch={handleSearchFinance}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="agreementType"
                        label="Financer agreement type"
                        rules={[
                          {
                            required: true,
                            message: "Please select agreement type",
                          },
                        ]}
                        //initialValue={EngData?.agreementType}
                      >
                        <Select
                          defaultValue="Select"
                          options={[
                            {
                              label: "Hypothecation",
                              value: "Hypothecation",
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label="Financer (City/Branch)"
                        name="FinancerCity"
                        rules={[
                          {
                            required: true,
                            message: "please input City/Branch",
                          },
                        ]}
                        //initialValue={EngData?.FinancerCity}
                      >
                        <Input
                          style={{ width: "100%", padding: "1px 8px" }}
                          placeholder="City/Branch"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : null}
                <Row justify={"center"}>
                  <div
                    className="h6 text-blue py-3 text-center mb-0"
                    style={{ fontSize: "20px", fontWeight: "700" }}
                  >
                    Registration Details
                  </div>
                </Row>
                <div className="py-3 pop-regaddress">
                  <Checkbox onChange={handleCheckboxChange}>
                    Is your registration address same as communication address ?
                  </Checkbox>
                </div>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label="Address"
                      name="Regaddress"
                      rules={[
                        {
                          required: true,
                          message: "please input Address",
                        },
                      ]}
                      initialValue={PospQuotePost?.Regaddress}
                    >
                      <Input style={{ width: "100%" }} placeholder="Address" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="City"
                      name="Regcity"
                      rules={[
                        {
                          required: true,
                          message: "please input City",
                        },
                      ]}
                      initialValue={PospQuotePost?.Regcity}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="City/District"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="Regstate"
                      label="State"
                      rules={[
                        {
                          required: true,
                          message: "Please select State",
                        },
                      ]}
                      initialValue={PospQuotePost?.Regstate}
                    >
                      <Select
                        defaultValue="Search for a state"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={options?.map((p) => ({
                          value: p.label,
                          label: p.label,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Pincode"
                      name="Regpincode"
                      rules={[
                        {
                          required: true,
                          message: "please input Pincode",
                        },
                      ]}
                      initialValue={PospQuotePost?.Regpincode}
                    >
                      <Input style={{ width: "100%" }} placeholder="Pincode" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"center"}>
                  <div
                    className="h6 text-blue py-3 text-center mb-0"
                    style={{ fontSize: "20px", fontWeight: "700" }}
                  >
                    Nominee Details
                  </div>
                </Row>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label="Nominee Name"
                      name="Nname"
                      rules={[
                        {
                          required: true,
                          message: "please input Nominee Name",
                        },
                      ]}
                      initialValue={PospQuotePost?.Nname}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="Nominee Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Nominee Relationship"
                      name="Nrelation"
                      rules={[
                        {
                          required: true,
                          message: "please input Nominee Relationship",
                        },
                      ]}
                      initialValue={PospQuotePost?.Nrelation}
                    >
                      <AutoComplete placeholder="Select Relationship">
                        {Relation.map((option) => (
                          <Option key={option.id} value={option.label}>
                            {option.label}
                          </Option>
                        ))}
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Nominee Date of Birth"
                      name="Nage"
                      rules={[
                        {
                          required: true,
                          message: "Please select DOB",
                        },
                      ]}
                      initialValue={
                        PospQuotePost?.Ndob ? moment(PospQuotePost?.Ndob) : null
                      }
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        disabledDate={disabledDate}
                        defaultPickerValue={getDefaultPickerValue()}
                        format="YYYY-MM-DD"
                        //onChange={onDateChange}
                        placeholder="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Form.Item
                className="mb-0 text-center py-3"
                {...buttonItemLayout}>
                  <Button  type="primary" htmlType="submit" loading={loading}>
                    Submit
                  </Button>
              </Form.Item> */}
                <div
                  className="bg-white position-sticky bottom-0"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex align-items-center justify-content-end container text-right py-2">
                    <p className="mb-0 mx-3">
                      By proceeding, you agree to the Terms & Conditions
                    </p>
                    <Form.Item className="mb-0" {...buttonItemLayout}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                      >
                        Send Request
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    product: state.vehicledetail.insuranceproduct,
    preinslist: state.vehicledetail.previnslist,
  };
};

export default connect(mapStateToProps)(PospDetail);
